import { Component, Input } from '@angular/core';
import { PayableTableObject } from '../models/payable-table-object';
import { InvoicePdfService } from '../service/invoice-pdf.service';
import { Store } from '@ngxs/store';
import { PaymentsState, RemoveArTranAllocations, SetArTranAllocations, UpdateArTranAllocations } from '@aiwyn/common/payments';
import { Observable } from 'rxjs';
import { ArTranAllocation } from '@aiwyn/api';
import { SnackbarService, SnackbarType } from '@aiwyn/shared';

@Component({
  selector: 'app-invoice-mobile-card',
  templateUrl: './invoice-mobile-card.component.html',
  styleUrls: ['./invoice-mobile-card.component.scss'],
  standalone: false,
})
export class InvoiceMobileCardComponent {
  @Input()
  invoiceTableDataObject: PayableTableObject;

  @Input()
  everyInvoiceBelongsToSameEntity: boolean;

  showPayableSelections$: Observable<boolean> = this.store.select(PaymentsState.getPayWithInvoices);

  constructor(
    public invoicePdfService: InvoicePdfService,
    public snackbarService: SnackbarService,
    private readonly store: Store,
  ) {}

  /**
   * Select or deselect the card.
   */
  toggleCard(): void {
    const payWithInvoices = this.store.selectSnapshot(PaymentsState.getPayWithInvoices);
    const isPayableAlreadySelected = this.store.selectSnapshot(PaymentsState.getSelectedPayableIds)
      .includes(this.invoiceTableDataObject.arTranId);
    this.invoiceTableDataObject.checked = !(payWithInvoices && isPayableAlreadySelected);

    if (!this.invoiceTableDataObject.checked) {
      this.store.dispatch(new RemoveArTranAllocations(this.invoiceTableDataObject.invoice.arTran.id));
      return;
    }

    const arTranAllocation: ArTranAllocation = {
      arTranId: this.invoiceTableDataObject.invoice.arTran.id,
      allocatedAmount: this.invoiceTableDataObject.amountRemaining,
      active: this.invoiceTableDataObject.invoice.arTran.active,
    };

    if (payWithInvoices) {
      this.store.dispatch(new UpdateArTranAllocations(arTranAllocation));
    } else {
      this.store.dispatch(new SetArTranAllocations(arTranAllocation));
    }
  }

  openSnackBar() {
    if (!this.invoiceTableDataObject.disabled) {
      return;
    }

    this.snackbarService.open('You can only select and pay invoices from the same business entity at the same time.', SnackbarType.WARNING);
  }
}
